export const Container = {
  position: 'relative',
  width: '100%',
  height: ['55vh', '55vh', '80vh'],
  maxHeight: ['55vh', '55vh', '80vh'],
  h1: {
    margin: 0,
  },
};

const ContentContainerWrapperValues = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 3,
  right: 3,
  zIndex: 2,
  pointerEvents: 'none',
};

const ContentContainerWrapperValuesFluid = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 2,
  pointerEvents: 'none',
};

export const ContentContainerWrapper = {
  fluid: {
    alpha: ContentContainerWrapperValuesFluid,
    alphaText: ContentContainerWrapperValuesFluid,
    blocks: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 6,
      zIndex: 2,
      pointerEvents: 'none',
    },
    picture: ContentContainerWrapperValuesFluid,
  },
  nonfluid: {
    alpha: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      pointerEvents: 'none',
    },
    alphaText: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      pointerEvents: 'none',
    },
    blocks: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      pointerEvents: 'none',
    },
    picture: ContentContainerWrapperValues,
  },
};

export const ContentContainer = {
  center: {},
  north: {},
  northEast: {
    height: '100%',
    paddingTop: 6,
    paddingBottom: [6, 6, 0],
    flexDirection: 'column',
    justifyContent: ['flex-end', 'flex-end', 'flex-start'],
    alignItems: ['flex-start', null, 'flex-end'],
    textAlign: ['left', null, 'right'],
  },
  east: {
    height: '100%',
    paddingBottom: [6, 6, 0],
    flexDirection: 'column',
    justifyContent: ['flex-end', 'flex-end', 'center'],
    alignItems: ['flex-start', null, 'flex-end'],
    textAlign: ['left', null, 'right'],
  },
  southEast: {
    height: '100%',
    paddingBottom: [3, 3, 6],
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: ['flex-start', null, 'flex-end'],
    textAlign: ['left', null, 'right'],
  },
  south: {},
  southWest: {},
  west: {},
  northWest: {},
};

const ContentBase = {
  display: 'flex',
  paddingY: [2, 2, 3],
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',
};

export const Content = {
  fluid: {
    alpha: {
      ...ContentBase,
      backgroundImage: [
        'linear-gradient(270deg, transparent, rgba(0,0,0,0.5))',
        null,
        'linear-gradient(90deg, transparent, rgba(0,0,0,0.5))',
      ],
      paddingX: [3, 4],
    },
    alphaText: {
      ...ContentBase,
      backgroundImage: [
        'linear-gradient(270deg, transparent, rgba(0,0,0,0.5))',
        null,
        'linear-gradient(90deg, transparent, rgba(0,0,0,0.5))',
      ],
      paddingX: [3, 4],
      maxWidth: ['100%', '100%', '75%'],
      width: ['100%', '100%', '75%'],
    },
    blocks: ContentBase,
    picture: ContentBase,
  },
  nonfluid: {
    alpha: {
      ...ContentBase,
      backgroundImage: [
        'linear-gradient(270deg, transparent, rgba(0,0,0,0.5))',
        null,
        'linear-gradient(90deg, transparent, rgba(0,0,0,0.5))',
      ],
      paddingX: [3, 4],
    },
    alphaText: {
      ...ContentBase,
      backgroundImage: [
        'linear-gradient(270deg, transparent, rgba(0,0,0,0.5))',
        null,
        'linear-gradient(90deg, transparent, rgba(0,0,0,0.5))',
      ],
      paddingX: [3, 4],
      maxWidth: ['100%', '100%', '75%'],
      width: ['100%', '100%', '75%'],
    },
    blocks: {
      ...ContentBase,
      // alignItems:
    },
    picture: ContentBase,
  },
};

const TitleBoxAlpha = {
  pointerEvents: 'all',
  color: '#fff',
};

const TitleBoxAlphaText = {
  pointerEvents: 'all',
  color: '#fff',
};

const TitleBoxBlocks = {
  pointerEvents: 'all',
  marginRight: 3,
  h1: {
    display: 'inline-block',
    color: 'onPrimary',
    backgroundColor: 'primary',
    paddingX: '0.2em',
    paddingY: '0.1em',
  },
};

const TitleBoxPicture = {
  display: 'none',
};

export const TitleBox = {
  fluid: {
    alpha: TitleBoxAlpha,
    alphaText: TitleBoxAlphaText,
    blocks: TitleBoxBlocks,
    picture: TitleBoxPicture,
  },
  nonfluid: {
    alpha: TitleBoxAlpha,
    alphaText: TitleBoxAlphaText,
    blocks: TitleBoxBlocks,
    picture: TitleBoxPicture,
  },
};

const SubtitleBoxAlpha = {
  pointerEvents: 'all',
  color: '#fff',
};

const SubtitleBoxAlphaText = {
  pointerEvents: 'all',
  color: '#fff',
};

const SubtitleBoxBlocks = {
  pointerEvents: 'all',
  marginRight: [0, null, 6],
  h1: {
    display: 'inline-block',
    paddingX: '0.2em',
    paddingY: '0.1em',
    color: 'onSecondary',
    backgroundColor: 'secondary',
  },
};

const SubtitleBoxPicture = {
  display: 'none',
};

export const SubtitleBox = {
  fluid: {
    alpha: SubtitleBoxAlpha,
    alphaText: SubtitleBoxAlphaText,
    blocks: SubtitleBoxBlocks,
    picture: SubtitleBoxPicture,
  },
  nonfluid: {
    alpha: SubtitleBoxAlpha,
    alphaText: SubtitleBoxAlphaText,
    blocks: {
      ...SubtitleBoxBlocks,
      marginRight: [0, null, -6],
    },
    picture: SubtitleBoxPicture,
  },
};

const ButtonBoxAlpha = {
  pointerEvents: 'all',
  color: '#fff',
  'button, a': {
    paddingY: [2, 3],
    paddingX: [3, 4],
    marginTop: 2,
    '&:nth-of-type(n+2)': { marginLeft: [null, null, 2] },
  },
};

const ButtonBoxAlphaText = {
  pointerEvents: 'all',
  color: '#fff',
  'button, a': {
    paddingY: [2, 3],
    paddingX: [3, 4],
    marginTop: 2,
    '&:nth-of-type(n+2)': { marginLeft: [null, null, 2] },
  },
};

const ButtonBoxBlocks = {
  pointerEvents: 'all',
  display: 'none',
};

const ButtonBoxPicture = {
  display: 'none',
};

export const ButtonBox = {
  fluid: {
    alpha: ButtonBoxAlpha,
    alphaText: ButtonBoxAlphaText,
    blocks: ButtonBoxBlocks,
    picture: ButtonBoxPicture,
  },
  nonfluid: {
    alpha: ButtonBoxAlpha,
    alphaText: ButtonBoxAlphaText,
    blocks: ButtonBoxBlocks,
    picture: ButtonBoxPicture,
  },
};
